import NotifIcon from 'assets/svg/notif-icon/notif-icon.svg'
import Badge from 'common/components/Badge'
import Popover from 'common/components/Popover'
import Typography from 'common/components/Typography'
import {
  ACTIVE_THEME_NAME,
  WEB_DESKTOP_RALALI_URL,
} from 'common/constants'
import theme from 'common/theme'
import ThemeColorHelper from 'lib/theme-color-helper'
import { useEffect } from 'react'
import useInView from 'react-cool-inview'
import Transaction from 'services/Notification/widgets/Notification/Transaction'
import { useStoreActions, useStoreState } from 'stores/hooks'
import styled from 'styled-components'

const Content = styled.div`
  display: flex;
  position: relative;
`
const HeaderNotif = styled.div`
  box-shadow: rgb(0 0 0 / 4%) 0 2px 8px 0;
  padding-bottom: 13px;
  padding-top: 13px;
  padding-left: 15px;
  margin-bottom: 8px;
  height: 20px;
`

const WrapperNotifIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  color: ${() =>
    ACTIVE_THEME_NAME === 'default'
      ? theme.colors.grayDark
      : theme.colors.custom.white};
`

interface INotification {
  isLogin?: boolean
  children?: any
  onOpenOverlay?: Function
  onCloseOverlay?: Function
}

function Notification({
  children,
  isLogin = false,
  onOpenOverlay,
  onCloseOverlay,
}: INotification): JSX.Element {
  const { orderNotification, promotion } = useStoreState(
    (state) => state,
  )
  const {
    getOrderNotification,
    readOrderNotification,
    readAllOrderNotification,
  } = useStoreActions((actions) => actions.orderNotification)

  const { getPromotion } = useStoreActions(
    (actions) => actions.promotion,
  )

  const unreadNotification = orderNotification.unread

  const { inView } = useInView<HTMLDivElement>({
    onEnter: ({ unobserve }) => unobserve(),
  })

  useEffect(() => {
    if (isLogin) getOrderNotification({})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      inView &&
      Object.entries(promotion.data).length === 0 &&
      !promotion.isError
    ) {
      getPromotion({})
    }
  }, [getPromotion, inView, promotion.data, promotion.isError])

  const openTransactionHandler = (isRead, notifId) => {
    if (!isRead && notifId) readOrderNotification(notifId)
  }

  const retryGetOrderNotification = () => {
    if (isLogin) getOrderNotification({})
  }

  const readAllTransactionNotification = () => {
    readAllOrderNotification('all')
  }

  const content = (
    <>
      <HeaderNotif data-ralali-id="notif-header">
        <Typography type="bparagraph">Pemberitahuan</Typography>
      </HeaderNotif>

      <Transaction
        key={0}
        data-ralali-id="transaction-notif"
        isLogin={isLogin}
        isLoading={orderNotification.isLoading}
        isError={orderNotification.isError}
        items={orderNotification.data}
        onContentClick={openTransactionHandler}
        retryGetData={retryGetOrderNotification}
        onClickReadAll={readAllTransactionNotification}
      />
    </>
  )

  return (
    <Content data-testid="notif-popover">
      <Popover
        onOpenOverlay={onOpenOverlay}
        onCloseOverlay={onCloseOverlay}
        full
        content={content}
        side="bottom"
        childrenColor={ThemeColorHelper('orange')}
      >
        {children || (
          <WrapperNotifIcon
            href={`${WEB_DESKTOP_RALALI_URL}/customer/notifikasi`}
          >
            <NotifIcon />
            {isLogin && unreadNotification > 0 && (
              <Badge
                content={
                  unreadNotification > 100
                    ? '99+'
                    : unreadNotification
                }
                borderRadius="10px"
                top="0px"
                right="-4px"
                backgroundColor={theme.colors.red}
              />
            )}
            {!isLogin && (
              <Badge
                top="7px"
                right="6px"
                width="10px"
                height="10px"
                border={`solid 1px ${theme.colors.white}`}
                backgroundColor={theme.colors.red}
              />
            )}
          </WrapperNotifIcon>
        )}
      </Popover>
    </Content>
  )
}

export default Notification
